


$(document).on("click", '.trigger_ajax_cart', function(e) {
     e.preventDefault(); 
$('button.product-form__submit').trigger('click');
var this_element =  jQuery(this);
this_element.addClass('loading_hk');
setTimeout(function() {
this_element.removeClass('loading_hk'); 
}, 1500);
  });

$(document).on("click", '.option_item', function(e) { 
$(this).parents('.custom_variants_landing_page').find('.option_item').removeClass('active');  
$(this).addClass('active');  
var selected_quantity = $(this).attr('quantity');
$('.trigger_ajax_cart').attr('quantity',selected_quantity);
var index_selected = $('.option_item.active').index();
$('.kaching-bundles .kaching-bundles__bar label').eq(index_selected).trigger('click');

});



$(window).on('load', function () {
$('.kaching-bundles .kaching-bundles__bar label').eq(0).trigger('click');
});


$(document).on("click", ".option_item.option_item_last_full", function (e) {
  setTimeout(function () {
var active_index = $('.free_gifts_item.active').index();
document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option').selectedIndex = active_index;

const select = document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option');
const changeEvent = new CustomEvent('change', {
bubbles: true,
cancelable: true,
composed: true,
detail: {
value: select.value,
source: 'programmatic',
},
});
select.dispatchEvent(changeEvent);
}, 500);
});



$(document).on("click", ".free_gifts_item", function (e) {
  e.preventDefault();
$('.free_gifts_item').removeClass('active');
$(this).addClass('active');
var active_index = $('.free_gifts_item.active').index();
  setTimeout(function () {
document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option').selectedIndex = active_index;

const select = document.querySelector('select.kaching-bundles__bar-variant-select.kaching-bundles-option');
const changeEvent = new CustomEvent('change', {
bubbles: true,
cancelable: true,
composed: true,
detail: {
value: select.value,
source: 'programmatic',
},
});
select.dispatchEvent(changeEvent);
}, 500);
});
